import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ error: null });
    window.location.assign('/');
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="state error" role="alert">
        <h2>Something went wrong</h2>
        <p>The page couldn't load. Try refreshing or returning home.</p>
        <button
          type="button"
          onClick={this.handleReset}
          style={{
            marginTop: 16,
            padding: '10px 20px',
            background: 'var(--accent)',
            color: '#0a0a0a',
            border: 0,
            borderRadius: 4,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Return home
        </button>
      </main>
    );
  }
}
